import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './app/styles/index.css';
import { brand } from './shared/lib/brand';

document.title = brand.title;

const container = document.getElementById('app');

if (!container) {
  throw new Error('Root element #app not found');
}

const root = createRoot(container);
root.render(<App />);
